module.exports = __webpack_public_path__ + "img/stadia-ios-ipad-home-framed_2x.dcc049d3.webp";